export default __webpack_public_path__ + "media/images/tenant/howToRentApartment/step_2-16dda0a9772591a9221477914742df5a.jpg";